module.exports = __webpack_public_path__ + "img/nodata2.2d501357.png";